exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.5.1@core-js/library/modules/_object-gops.js
// module id = 23
// module chunks = 0